<template>
  <div>
    <Input placeholder="Address Line 1" :inputValue.sync="data.addressLine1" :isDisabled="viewMode" />
    <Input placeholder="Address Line 2" :inputValue.sync="data.addressLine2" :isDisabled="viewMode" />
    <Input placeholder="Address Line 3" :inputValue.sync="data.addressLine3" :isDisabled="viewMode" />
    <Input placeholder="Address Line 4" :inputValue.sync="data.addressLine4" :isDisabled="viewMode" />
    <div class="flex-row">
      <Dropdown placeholder="Postcode" style="padding-right: 5px" :selectedObject.sync="data.selectedPostcode" :items="data.postcodeItems"
        :search.sync="data.postcodeSearch" @selected="postcodeSelected" :isDisabled="viewMode" itemKey="PostCode" />
      <Input placeholder="City" style="padding-left: 5px" :inputValue.sync="data.city" :isDisabled="viewMode" />
    </div>
    <div class="flex-row">
      <Dropdown placeholder="State" style="padding-right: 5px" :selectedObject.sync="data.selectedState" :items="data.stateItems"
        :search.sync="data.stateSearch" :isDisabled="viewMode" itemKey="State" />
      <Dropdown placeholder="Country" style="padding-left: 5px" :selectedObject.sync="data.selectedCountry" :items="data.countryItems"
        :search.sync="data.countrySearch" :isDisabled="viewMode" itemKey="Country" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },

    // data example
    // data: {
    //   addressLine1: '',
    //   addressLine2: '',
    //   addressLine3: '',
    //   addressLine4: '',
    //   selectedPostcode: null, postcodeItems: [], postcodeSearch: '', postcodeKey: '',
    //   city: '',
    //   selectedState: null, stateItems: [], stateSearch: '', stateKey: '',
    //   selectedCountry: null, countryItems: [], countrySearch: '', countryKey: ''
    // }

  },
  methods: {
    postcodeSelected: function(e) {
      this.data.city = e.City.trim().toUpperCase();
      let state = this.data['stateItems'].find(s => s[this.data['stateKey'] ? this.data['stateKey'] : 'State'].trim().toUpperCase() == e['State'].trim().toUpperCase());
      if (state) { this.data['selectedState'] = state }
      let country = this.data['countryItems'].find(s => s[this.data['countryKey'] ? this.data['countryKey'] : 'Country'].trim().toUpperCase() == e['Country'].trim().toUpperCase());
      if (country) { this.data['selectedCountry'] = country }
    }
  },
  mounted() {
    if (process.env['NODE_ENV'] == 'development') {
      console.warn(`You are using <AddressForm /> which is deprecated. Please use <AddressFormV2 /> instead.`);
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.flex-row {
  display: flex;
}
</style>